import { useTranslation as useReactI18nextTranslation, Trans } from 'react-i18next';

export { Trans };

export const usePaldockTranslation = (keyPrefix?: string) => {
    const { t: originalT, i18n } = useReactI18nextTranslation(undefined, { keyPrefix });

    const t = (...args: Parameters<typeof originalT>): ReturnType<typeof originalT> => {
        const translatedText = originalT(...args);
        //const fullKey = keyPrefix ? `${keyPrefix}.${key}` : key;

        // Return a span with title attribute showing the translation key
       /* return (
            <span title={fullKey} style={{ cursor: 'help' }}>
                {translatedText}
            </span>
        ) as ReactElement;*/
        return translatedText;
    };

    return { t, i18n };
};
